import { render, staticRenderFns } from "./ModuleSearchSlidebar.vue?vue&type=template&id=23796b68"
import script from "./ModuleSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports